var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex bg-gray-200"},[_c('div',{staticClass:"mx-auto text-gray-500 text-xs py-2"},[_vm._v("KOSTENLOSER VERSAND")])])}]

export { render, staticRenderFns }